import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroLancamentosContasReceber } from '@/features/relatorio/page/financeiro/lancamentos-contas-receber/RelatorioFinanceiroLancamentosContasReceber';

export const Route = createFileRoute('/a/relatorio/financeiro/lancamentos-contas-receber')({
    component: RelatorioFinanceiroLancamentosContasReceber,
});
